import FormaPagamentoModel from "../../models/financeiro/formaPagamentoModel";

import { IService } from "./../base/iService";

export default class FormaPagamentoService extends IService<FormaPagamentoModel> {
    constructor() {
        super("FormaPagamento");
    }
}
